import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../contexts/AuthContext';
import { useTenant } from '../../../contexts/TenantContext';
import Sidebar from '../../admin-dashboard/components/Sidebar';

/**
 * Admin V2 AI — Phase ultérieure shell. Feature : pages.ai.admin (OFF).
 * Nécessite une Edge Function `generic-claude-proxy` + clé API Claude (config
 * super_admin). Cette page est un placeholder structuré tant que ce n'est pas
 * branché.
 */
const AdminV2AI = ({ titleKey = 'aiV2.adminTitle', titleFallback = 'AI analytics' }) => {
  const { t } = useTranslation();
  const { userProfile } = useAuth();
  const { tenantName } = useTenant();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen bg-background text-foreground">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} userEmail={userProfile?.email} />
      <main className="flex-1 min-w-0 overflow-x-hidden">
        <header className="border-b border-border bg-card sticky top-0 z-10">
          <div className="px-4 md:px-6 py-4">
            <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground">{t(titleKey, titleFallback)}</h1>
            <p className="text-xs text-muted-foreground mt-0.5">{tenantName}</p>
          </div>
        </header>
        <div className="p-4 md:p-6">
          <div className="rounded-2xl bg-card border border-border p-8 md:p-12 text-center">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-accent/10 mb-4">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-accent">
                <path d="M12 3l2 5 5 2-5 2-2 5-2-5-5-2 5-2 2-5z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
              </svg>
            </div>
            <h2 className="text-lg font-heading font-semibold text-foreground">{t('aiV2.stubTitle', 'AI assistant')}</h2>
            <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">
              {t('aiV2.stubBody', 'AI features require a Claude API proxy (generic-claude-proxy Edge Function) and an API key configured by the super admin. Enabled per tenant once wired.')}
            </p>
            <span className="inline-block mt-4 text-[10px] uppercase tracking-widest px-2 py-1 rounded-full bg-muted text-muted-foreground">Claude API · à configurer</span>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminV2AI;
